<template>
	<Modal
		:modal-name="modalName"
		:type="size === 'medium' ? 'dialog-md' : 'dialog-lg'"
		class="modal-keyboard-shortcuts"
		:theme="$arenaConfig?.isLightTheme ? 'light' : 'dark'"
		@opened="handleOpen"
	>
		<template #title>
			{{ $I18n.trans('one.keyboard_shortcuts.title') }}
		</template>
		<template #content>
			<div class="modal-keyboard-shortcuts__content-w">
				<div
					v-for="(shortcut, index) in keyboardShortcuts"
					:key="index"
					class="modal-keyboard-shortcuts__shortcut"
				>
					<div class="modal-keyboard-shortcuts__shortcut-key-w">
						<span
							v-for="(key, index_key) in shortcut.keys"
							:key="index_key"
							class="modal-keyboard-shortcuts__shortcut-key"
						>
							{{ key }}
						</span>
					</div>
					<div class="modal-keyboard-shortcuts__shortcut-description">
						{{ shortcut.description }}
					</div>
				</div>
			</div>
		</template>
	</Modal>
</template>

<script>
import Modal from '@shared/components/Modal.vue';

export default {
	name:       'ModalKeyboardShortcuts',
	components: { Modal },
	props:      {
		modalName: {
			type:     String,
			required: true,
		},
		size: {
			type:      String,
			required:  false,
			default:   'large',
			validator: (value) => {
				return ['medium', 'large'].includes(value);
			},
		},
	},
	data() {
		return {
			keyboardShortcuts: [],
		};
	},
	methods: {
		closeModal() {
			window.eventBus.$emit(`modalClose:${this.modalName}`);
		},
		/**
		 * @param {Object[]} shortcuts
		 * @param {string} shortcuts.key
		 * @param {string} shortcuts.description
		 * @param {boolean} shortcuts.shiftKey
		 * @returns {Object[]}
		 */
		handleOpen(shortcuts) {
			this.keyboardShortcuts = shortcuts.map(shortcut => {
				return this.transformKey(shortcut);
			});
		},
		transformKey(shortcut) {
			const keys = [];
			const keyUpperCase = shortcut.key.toUpperCase();
			if (keyUpperCase === ' ') {
				keys.push('Space');
			} else if (keyUpperCase === 'ARROWUP') {
				keys.push('↑');
			} else if (keyUpperCase === 'ARROWDOWN') {
				keys.push('↓');
			} else if (keyUpperCase === 'ARROWLEFT') {
				keys.push('←');
			} else if (keyUpperCase === 'ARROWRIGHT') {
				keys.push('→');
			} else if (keyUpperCase === 'ESCAPE') {
				keys.push('Esc');
			} else {
				keys.push(keyUpperCase);
			}

			if (shortcut.shiftKey) {
				keys.unshift('⇧');
			}

			/**
				 * If needed:
				 * Control	⌃	U+2303
				 * Option	⌥	U+2325
				 * Command	⌘	U+2318
				 * Caps Lock	⇪	U+21EA
				 * Escape	⎋	U+238B
				 * Return	⏎	U+23CE
				 * Delete	⌫	U+232B
				 * Forward Delete	⌦	U+2326
				 * Tab	⇥	U+21E5
				 */

			return {
				keys:        keys,
				description: shortcut.description,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.modal-keyboard-shortcuts {
	@include font-size(fs-100);
}

.modal-keyboard-shortcuts__content-w {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	grid-template-rows: repeat(11, auto);
	grid-auto-flow: column;
	gap: $sp3-5;
}

.modal-keyboard-shortcuts__shortcut {
	display: flex;
	align-items: center;
	line-height: 1;
}

.modal-keyboard-shortcuts__shortcut-key-w {
	display: flex;
	gap: $sp2;
	min-width: 90px;
}

.modal-keyboard-shortcuts__shortcut-key {
	display: inline-block;
	border: 1px solid var(--color-grey-700);
	border-radius: 8px; // stylelint-disable-line
	padding: 0 $sp3;
	flex-basis: 36px;
	flex-grow: 0;
	flex-shrink: 0;
	height: 36px; // stylelint-disable-line
	display: flex;
	align-items: center;
	justify-content: center;
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", sans-serif; // stylelint-disable-line
}

// .modal-keyboard-shortcuts__shortcut-description {}
</style>
